"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useOnScreen;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
// Inspired by https://github.com/WebDevSimplified/useful-custom-react-hooks/blob/main/src/14-useOnScreen/useOnScreen.js

function useOnScreen(ref) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    rootMargin: '0px'
  };
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  (0, _react.useEffect)(function () {
    if (!ref.current) {
      return;
    }
    var observer = new IntersectionObserver(function (_ref) {
      var _ref2 = (0, _slicedToArray2["default"])(_ref, 1),
        entry = _ref2[0];
      return setIsVisible(entry.isIntersecting);
    }, options);
    observer.observe(ref.current);
    return function () {
      if (!ref.current) {
        return;
      }
      observer.unobserve(ref.current);
    };
  }, [ref.current, options]);
  return isVisible;
}